module.exports = __webpack_public_path__ + "assets/img/u1.5d6684da.png";